/**
 * Easy-Wholesale – Product-Unit-Stepping
 * ▸ PDP and Bulk-Order-Form
 * ▸ Metafield: custom.verpackungseinheit  (Integer, storefront-visible)
 */

const TOKEN = '3e262822e3225185474904b923bdd1b4';

const packUnits = {};
async function fetchUnits(ids){
  const todo = ids.filter(id => !(id in packUnits));
  if (!todo.length) return;

  const gids  = todo.map(id => `gid://shopify/Product/${id}`);
  const query = `
    query($ids:[ID!]!){
      nodes(ids:$ids){
        ... on Product{
          id
          metafield(namespace:"custom", key:"verpackungseinheit"){ value }
        }
      }
    }`;

  const res = await fetch('/api/2023-10/graphql.json',{
    method :'POST',
    headers:{
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token': TOKEN
    },
    body: JSON.stringify({ query, variables:{ ids:gids } })
  });
  const json = await res.json();
  json.data.nodes.forEach(n=>{
    packUnits[n.id.split('/').pop()] = parseInt(n.metafield?.value || 1,10);
  });
}

function fireAppEvents(inp){
  ['input','change','keyup','keydown'].forEach(ev=>
    inp.dispatchEvent(new Event(ev,{bubbles:true}))
  );
  if(typeof CustomEvent!=='undefined'){
    inp.dispatchEvent(new CustomEvent('nm-easywholesale-change',{bubbles:true}));
  }
}

function updatePageFooter(){
  const form = document.getElementById('product_form_page'); if(!form) return;
  let qty=0,sum=0;
  form.querySelectorAll('input.nm-easywholesale-qty').forEach(i=>{
    const q=parseInt(i.value,10)||0;
    qty+=q; sum+=q*(parseInt(i.dataset.price||0,10));
  });
  const qL=form.querySelector('.nm-total-selected-items');
  const sL=form.querySelector('.nm-total-summ-selected');
  if(qL) qL.textContent = qty;
  if(sL) sL.textContent =
    (sum/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'});
  const btn=form.querySelector('.nm-wholesale-btn-add-to-cart[data-formname="page"]');
  if(btn){
    const on=qty>0;
    btn.classList.toggle('nm-wholesale-btn-add-to-cart-disabled',!on);
    btn.classList.toggle('nm-wholesale-btn-add-to-cart-enabled', on);
    btn.disabled = !on; btn.style.pointerEvents = on?'auto':'none';
  }
}

document.addEventListener('click',async e=>{
  const btn=e.target.closest('.nm-easywholesale-qty-increase,.nm-easywholesale-qty-decrease');
  if(!btn) return;

  const inp=document.getElementById(btn.dataset.id); if(!inp) return;
  const pid=btn.closest('.nm-wholesale-table-container')?.dataset.productid;
  if(pid && !(pid in packUnits)) await fetchUnits([pid]);
  const unit=packUnits[pid]||1;
  const isInc=btn.classList.contains('nm-easywholesale-qty-increase');

  Promise.resolve().then(()=>{
    let q=parseInt(inp.value,10)||0;
    q = isInc ? Math.ceil (q/unit)*unit
              : Math.floor(q/unit)*unit;
    if(q<0) q=0;
    if(q!==parseInt(inp.value,10)){
      inp.value=q;
      fireAppEvents(inp);
      if(document.getElementById('product_form_page')) updatePageFooter();
    }
  });
}, false);

/*──────── 3 | Plus / Minus-Buttons --------------------------------*/
document.addEventListener('click', async e => {
  const btn = e.target.closest(
    '.nm-easywholesale-qty-increase, .nm-easywholesale-qty-decrease'
  );
  if (!btn) return;

  const inp = document.getElementById(btn.dataset.id);
  if (!inp) return;

  const pid = btn.closest('.nm-wholesale-table-container')?.dataset.productid;
  if (pid && !(pid in packUnits)) await fetchUnits([pid]);
  const unit = packUnits[pid] || 1;

  /* 30 ms warten, bis Easy-Wholesale den ±1-Schritt ausgeführt hat */
  setTimeout(() => {
    let val = parseInt(inp.value, 10) || 0;

    if (unit > 1) {
      if (btn.classList.contains('nm-easywholesale-qty-increase')) {
        val = Math.ceil(val / unit) * unit;          // aufrunden
      } else {
        val = Math.floor(val / unit) * unit;         // abrunden
      }
      if (val === 0 && btn.classList.contains('nm-easywholesale-qty-increase'))
        val = unit;                                  // 0 → erste VE
    }

    inp.value = val;
    fireAppEvents(inp);
    updatePageFooter();
  }, 30);
}, false);